/* ═══════════════════════════════════════════════════
   LUCA BIANCHI · lb-main.js
   Header · Mobile Menu · Cart Drawer · Gallery
   Variants · Add to Cart AJAX · Accordion · Reveal
   ═══════════════════════════════════════════════════ */
(function(){'use strict';

/* ── HEADER SCROLL (home-aware, gestore unico) ── */
var header=document.getElementById('lb-header');
var ann=document.querySelector('.lb-announcement');
var annH=ann?ann.offsetHeight:0;
if(header){
  var isHome=document.body.classList.contains('template-index');
  function onScroll(){
    header.classList.toggle('scrolled', !isHome || window.scrollY>60);
    if(ann)header.style.top=(window.scrollY>annH?'0':annH+'px');
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
}

/* ── MOBILE MENU ── */
var mMenu=document.getElementById('lb-mobile-menu');
document.querySelectorAll('.lb-menu-toggle').forEach(function(btn){
  btn.addEventListener('click',function(){
    var open=mMenu&&mMenu.classList.toggle('open');
    document.body.style.overflow=open?'hidden':'';
    var toggle=document.querySelector('.lb-menu-toggle.lb-icon-btn');
    if(toggle)toggle.classList.toggle('active',!!open);
  });
});

/* ── SEARCH BAR ── */
var sBar=document.getElementById('lb-search-bar');
document.querySelectorAll('.lb-search-toggle').forEach(function(btn){
  btn.addEventListener('click',function(){
    if(!sBar)return;
    var open=sBar.classList.toggle('open');
    sBar.setAttribute('aria-hidden',!open);
    if(open)setTimeout(function(){var inp=sBar.querySelector('input');if(inp)inp.focus();},100);
  });
});

/* ── CART DRAWER ── */
var cDrawer=document.getElementById('lb-cart-drawer');
function openCart(){if(cDrawer){cDrawer.classList.add('open');document.body.style.overflow='hidden';cDrawer.setAttribute('aria-hidden','false');}}
function closeCart(){if(cDrawer){cDrawer.classList.remove('open');document.body.style.overflow='';cDrawer.setAttribute('aria-hidden','true');}}
document.querySelectorAll('.lb-cart-toggle').forEach(function(btn){
  btn.addEventListener('click',function(){
    if(cDrawer&&cDrawer.classList.contains('open'))closeCart();else openCart();
  });
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();if(mMenu)mMenu.classList.remove('open');document.body.style.overflow='';if(sBar)sBar.classList.remove('open');}});

/* ── CART AJAX UPDATE (drawer) ── */
function updateCartItem(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
  .then(function(r){return r.json();})
  .then(function(cart){refreshCartUI(cart);})
  .catch(function(e){console.error('Cart error',e);});
}
function refreshCartUI(cart){
  document.querySelectorAll('[data-cart-count]').forEach(function(el){el.dataset.cartCount=cart.item_count;});
  var count=document.querySelector('.lb-cart-count');
  if(count){count.textContent=cart.item_count;count.style.display=cart.item_count>0?'flex':'none';}
  var toggle=document.querySelector('.lb-cart-toggle[data-cart-count]');
  if(toggle)toggle.setAttribute('aria-label','Carrello ('+cart.item_count+' articoli)');
  // Reload drawer body
  fetch('/cart?sections=lb-cart-drawer-body')
  .then(function(r){return r.json();})
  .catch(function(){});
}
document.addEventListener('click',function(e){
  var minus=e.target.closest('.lb-qty__btn--minus[data-key]');
  var plus=e.target.closest('.lb-qty__btn--plus[data-key]');
  var remove=e.target.closest('.lb-cart-drawer__remove,.lb-cart-item__remove');
  if(minus){var inp=document.querySelector('.lb-qty__input[data-key="'+minus.dataset.key+'"],.lb-qty__num[data-key="'+minus.dataset.key+'"]');var q=parseInt((inp?inp.textContent||inp.value:1),10);if(q>0)updateCartItem(minus.dataset.key,q-1);}
  if(plus){var inp2=document.querySelector('.lb-qty__input[data-key="'+plus.dataset.key+'"],.lb-qty__num[data-key="'+plus.dataset.key+'"]');var q2=parseInt((inp2?inp2.textContent||inp2.value:1),10);updateCartItem(plus.dataset.key,q2+1);}
  if(remove){updateCartItem(remove.dataset.key,0);}
});
// Cart page qty inputs
document.querySelectorAll('.lb-qty__input').forEach(function(inp){
  inp.addEventListener('change',function(){
    if(this.dataset.key)updateCartItem(this.dataset.key,parseInt(this.value,10)||0);
    else{var v=parseInt(this.value,10);if(v<1)this.value=1;}
  });
});
// Cart page qty buttons (no data-key = product page)
document.addEventListener('click',function(e){
  var btn=e.target.closest('.lb-qty__btn');
  if(!btn||btn.dataset.key)return;
  var qty=btn.closest('.lb-qty');
  if(!qty)return;
  var inp=qty.querySelector('.lb-qty__input');
  if(!inp)return;
  var v=parseInt(inp.value,10)||1;
  if(btn.classList.contains('lb-qty__btn--minus')&&v>1)inp.value=v-1;
  if(btn.classList.contains('lb-qty__btn--plus'))inp.value=v+1;
});

/* ── ADD TO CART ── */
var atcForm=document.getElementById('lb-atc-form');
if(atcForm){
  atcForm.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=this.querySelector('[name="add"]');
    var orig=btn.textContent;
    btn.disabled=true;btn.textContent='Aggiunta...';
    var fd=new FormData(this);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(fd.get('id'),10),quantity:parseInt(fd.get('quantity'),10)||1})})
    .then(function(r){return r.json();})
    .then(function(){
      btn.textContent='✓ Aggiunto';
      var msg=document.getElementById('lb-atc-msg');if(msg)msg.style.display='block';
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(refreshCartUI);
      setTimeout(function(){btn.disabled=false;btn.textContent=orig;if(msg)msg.style.display='none';openCart();},1800);
    })
    .catch(function(err){console.error('ATC error',err);btn.disabled=false;btn.textContent=orig;});
  });
}

/* ── GALLERY ── */
var galleryMain=document.getElementById('lb-gallery-main');
if(galleryMain){
  var slides=galleryMain.querySelectorAll('.lb-gallery__slide');
  var thumbs=document.querySelectorAll('.lb-gallery__thumb');
  var cur=0;
  function goTo(i){slides.forEach(function(s,j){s.classList.toggle('active',j===i);});thumbs.forEach(function(t,j){t.classList.toggle('active',j===i);});cur=i;}
  thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(parseInt(this.dataset.index,10));});});
  var sX=0;
  galleryMain.addEventListener('touchstart',function(e){sX=e.touches[0].clientX;},{passive:true});
  galleryMain.addEventListener('touchend',function(e){var d=sX-e.changedTouches[0].clientX;if(Math.abs(d)>50)goTo((cur+(d>0?1:-1)+slides.length)%slides.length);},{passive:true});
}

/* ── VARIANTS ── */
var variantBtns=document.querySelectorAll('.lb-variant-btn');
if(variantBtns.length){
  variantBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var pos=this.dataset.pos;
      document.querySelectorAll('.lb-variant-btn[data-pos="'+pos+'"]').forEach(function(b){b.classList.remove('active');});
      this.classList.add('active');
      var lbl=document.querySelector('.lb-variant-current[data-pos="'+pos+'"]');
      if(lbl)lbl.textContent=this.dataset.val;
      findVariant();
    });
  });
  function getOpts(){var o={};document.querySelectorAll('.lb-variant-btn.active').forEach(function(b){o[b.dataset.pos]=b.dataset.val;});return o;}
  function findVariant(){
    var pj=document.getElementById('lb-product-json');if(!pj)return;
    try{
      var prod=JSON.parse(pj.textContent);
      var opts=getOpts();
      var keys=Object.keys(opts);
      var match=prod.variants.find(function(v){return keys.every(function(k){return v['option'+k]===opts[k];});});
      if(match){
        var vid=document.getElementById('lb-variant-id');if(vid)vid.value=match.id;
        var pc=document.querySelector('.lb-product__price-current');if(pc)pc.textContent=fmtMoney(match.price);
        var atcBtn=document.getElementById('lb-atc-btn');
        if(atcBtn){atcBtn.disabled=!match.available;atcBtn.textContent=match.available?'Aggiungi al carrello →':'Non disponibile';}
      }
    }catch(e){console.error('Variant error',e);}
  }
  function fmtMoney(c){return'€'+(c/100).toFixed(2).replace('.',',');}
}

/* ── ACCORDION ── */
document.querySelectorAll('.lb-acc__trigger').forEach(function(t){
  t.addEventListener('click',function(){
    var item=this.closest('.lb-acc__item');
    var open=item.classList.contains('open');
    document.querySelectorAll('.lb-acc__item').forEach(function(i){i.classList.remove('open');i.querySelector('.lb-acc__trigger').setAttribute('aria-expanded','false');});
    if(!open){item.classList.add('open');this.setAttribute('aria-expanded','true');}
  });
});

/* ── SCROLL REVEAL ── */
var reveals=document.querySelectorAll('.lb-reveal');
if(reveals.length&&'IntersectionObserver' in window){
  var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  reveals.forEach(function(el){obs.observe(el);});
}

/* ── HERO SCROLL LINE PULSE → ora gestito in CSS (nessun JS in loop) ── */

})();
